import fileSys from "../fileoprators/fileSystem";
import SettingsOprator from "./settingsoprator";
import { CAMPLAMP, CAMPLAMP_OLD } from "./consts";

class Cam extends SettingsOprator {
  constructor() {
    super(fileSys.getCalibPath("camLampCfg.json"), window.isNewSN() ? CAMPLAMP : CAMPLAMP_OLD);
  }
  getCamSettings() {
    return this.getSettings();
  }
  saveCamSettings(settings) {
    this.saveSettings(settings);
  }
}
export default Cam;



// WEBPACK FOOTER //
// ./src/settings/camlamp.js